import JSONModel from "sap/ui/model/json/JSONModel";
import BaseController from "../controller/BaseController";
import { EnvironmentService } from "../service/Environment.service";
import { ListItemBase$PressEvent } from "sap/m/ListItemBase";
import { ErrorHandler } from "../service/ErrorHandler.service";
import Dialog from "sap/m/Dialog";
import { Button$PressEvent } from "sap/m/Button";

/**
 * @namespace com.unitrade.crm.blocks
 */
export default class VisitReport extends BaseController {
  private _oModel: JSONModel;
  private _oMoreModel: JSONModel;
  private _oBesuchsberichteListeDialog: Dialog;

  onInit(): void {
    this._oModel = new JSONModel();
    this._oMoreModel = new JSONModel();
    this.setModel(this._oModel);
    this.setModel(this._oMoreModel, "more");
    this.getView().attachModelContextChange(null, this.onModelContextChange.bind(this));
  }

  async onModelContextChange(oEvent: Event) {
    await this._callWithCustomer(this._loadBesuchsberichte);
  }

  onBesuchsBerichtPress = (oEvent: ListItemBase$PressEvent) => {
    const oItem = oEvent.getSource();
    const oBindingContext = oItem.getBindingContext() ?? oItem.getBindingContext("more");
    const oModel = oBindingContext.getModel();
    const id = oModel.getProperty("id", oBindingContext) as number;
    this.getOwnerComponent().getRouter().navTo("visitReport", { idPath: id });
  };

  onAddVisitReportClick = async (oEvent: Button$PressEvent) => {
    await this._callWithCustomer(this._navigateToAddVisitReport);
  };

  onDisplayMoreVisitsClick = async (oEvent: Button$PressEvent) => {
    await this._callWithCustomer(this._loadMoreBesuchsberichte);
  };

  onDialogDisplayMoreCancelPress = (oEvent: Button$PressEvent) => {
    if (this._oBesuchsberichteListeDialog) {
      this._oBesuchsberichteListeDialog.close();
    }
  };

  private _callWithCustomer = async (fn: (kundid: number, kundlfd: number) => Promise<any>) => {
    const oCustomerModel = this.getModel("Customer");
    if (oCustomerModel) {
      const kundId = oCustomerModel.getProperty("/id");
      const kundLfd = oCustomerModel.getProperty("/lfd");
      if (kundId && kundLfd) {
        await fn(kundId, kundLfd);
      }
    }
  };

  private _loadBesuchsberichte = async (kundId: number, kundLfd: number) => {
    await this._oModel.loadData(`${EnvironmentService.getBaseUrl()}/besuchsbericht/kunde/besuchsberichte?kundeId=${kundId}&kundeLfd=${kundLfd}&limit=6`);
  };

  private _loadMoreBesuchsberichte = async (kundId: number, kundLfd: number) => {
    try {
      if (!this._oBesuchsberichteListeDialog) {
        this._oBesuchsberichteListeDialog = (await this.loadFragment({ name: "com.unitrade.crm.fragments.BesuchsberichteListeDialog" })) as Dialog;
      }

      await this._oMoreModel.loadData(`${EnvironmentService.getBaseUrl()}/besuchsbericht/kunde/besuchsberichte?kundeId=${kundId}&kundeLfd=${kundLfd}&limit=100`);
      this._oBesuchsberichteListeDialog.open();
    } catch (ex: any) {
      ErrorHandler.handleError(ex);
    }
  };

  private _navigateToAddVisitReport = async (kundId: number, kundLfd: number) => {
    this.getOwnerComponent().getRouter().navTo("visitReportForCustomer", { kundid: kundId, kundlfd: kundLfd });
  };

  public teilnehmerToCommaSeparatedContacts(data: any[]) {
    if (data == null) {
      return "";
    }

    return data.map((z) => z.name).join(", ");
  }
}
